








































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";

export default Vue.extend({
  name: "AudioController",
  components: {
    BaseSimpleSlider,
    BaseVideoRangeSlider,
    BaseCheckbox,
    BaseInput,
  },
  data: function () {
    return {};
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    audioParameters: function () {
      return this.$store.state.audioParameters;
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {},
});
